import { RouteObject } from "react-router-dom";
import OtpMaximumAttempt from "./OtpMaximumAttempt/OtpMaximumAttempt";
import FeatureLogin from "./Feature_Login";
// import PolicyAndConditionsPage from ;
import { R_LoginRoutes } from "../../utils/Routes";
import SuspenseWrapper from "../../components/CustomLazyLoading/CustomLazyLoading";
import { lazy } from "react";
const PolicyAndConditionsPage = lazy(
  () =>
    import(
      "../Feature_GeneralAppElements/PolicyAndConditionsPage/PolicyAndConditionsPage"
    )
);
const LoginRoutes: RouteObject[] = [
  {
    path: R_LoginRoutes.login,
    element: <FeatureLogin />,
  },
  {
    path: R_LoginRoutes.policyAndConditions,
    element: <SuspenseWrapper LazyLoadingComponent={PolicyAndConditionsPage} />,
  },
  // {
  //   path: "maximumOtpAttempt",
  //   element: <OtpMaximumAttempt />,
  // },
];
export default LoginRoutes;
